// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 474 ? "fe69a73d" : chunkId) + "." + {"474":"1400cf9f9af4d218","7312":"19e2199c6f1124e8","7953":"98b0ca49ca95b4c7"}[chunkId] + ".js";
};